import { getApi, postApi, putApi} from "../api";


export const createSubscriptionApi = (data)=> postApi(`masters/subscription/create`, data)
export const viewSubscriptionApi = ()=> getApi(`masters/subscription/all`)
export const updateSubscriptionApi = (id, data)=> putApi(`masters/subscription/update/${id}`, data)
